import { TabletStatus } from './tablet-status'

export class TabletDetails{
  status?: TabletStatus
  latestDateTime?: string

  constructor(params?: Partial<TabletDetails>) {
    Object.assign(this, params)
  }
}
